import React, { FC } from "react";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { ClearConditionsButtonContainer } from "../styled";

export const ClearConditionsButton: FC<{ disabled?: boolean; clearConditions: VoidFunction }> = ({
  disabled,
  clearConditions,
}) => {
  const { t } = useTranslation("layerFilter");

  return (
    <ClearConditionsButtonContainer>
      <IconButton kind={"clear"} onClick={clearConditions} title={t("clearQuery")} disabled={disabled} />
    </ClearConditionsButtonContainer>
  );
};
